module.exports = __webpack_public_path__ + "img/award.c68a628c.svg";